// localStorage key 값으로 사용할 상수를 정의합니다.
export const LOCAL_STORAGE_HVM_CONFIG_DATE = 'hvm_config_date';
export const LOCAL_STORAGE_HVM_CONFIG = 'hvm_config';
export const LOCAL_STORAGE_HVM_USERINFO = 'hvm_userinfo';
export const LOCAL_STORAGE_HVM_SAVED_ID = 'hvm_saved_id';

// default Image Path
export const DEFAULT_BANNER_HERO_PC_IMAGE = require('@/assets/images/main/main_banner_img_pc.jpg'); // TODO: 기본 이미지로 변경 필요 (현재는 메인 시안의 배너 이미지)
export const DEFAULT_BANNER_HERO_MO_IMAGE = require('@/assets/images/m/main/main_banner_img_mo.jpg'); // TODO: 기본 이미지로 변경 필요 (현재는 메인 시안의 배너 이미지)
export const DEFAULT_BANNER_MAIN_IMAGE = require('@/assets/images/brand/brand_logo3.png'); // TODO: 기본 이미지로 변경 필요 (현재는 스타벅스 로고 이미지)
export const DEFAULT_BRAND_LOGO_IMAGE = require('@/assets/images/brand/brand_logo3.png'); // TODO: 기본 이미지로 변경 필요 (현재는 스타벅스 로고 이미지)
export const DEFAULT_NO_IMAGE = require('@/assets/images/brand/no_image.png'); // TODO: 기본 이미지로 변경 필요 (현재는 스타벅스 로고 이미지)